var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.753c0-1.654 1.346-3 3-3h16c1.654 0 3 1.346 3 3V24H5v-4.247zm16.91-5H10.09c.273-1.724 1.168-3.19 1.729-3.19h8.362c.561 0 1.456 1.466 1.729 3.19zM7 8c0-1.654 1.345-3 3-3h12c1.654 0 3 1.346 3 3v6.855a4.916 4.916 0 00-1-.102h-.067c-.308-2.424-1.678-5.19-3.752-5.19h-8.363c-2.072 0-3.444 2.766-3.752 5.19h-.067c-.342 0-.676.035-1 .102V8zM5 29v-3h22v3h2v-9.247c0-1.627-.794-3.061-2-3.975V8c0-2.757-2.244-5-5-5H10C7.241 3 5 5.243 5 8v7.778c-1.208.914-2 2.348-2 3.975V29h2z",
    fill: props.color
  })));
}

export default SvgIconBed;